import api from '@/services/api/config';

const path = 'v1/assets-infrastruktur/gruppe';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
  create: (gruppe) => api.post(path, gruppe),
  rename: (id, gruppe) => api.patch(`${path}/${id}/name`, gruppe),
  delete: (id) => api.delete(`${path}/${id}`),
};
